import type { SchemaBuilderFormModalProps } from "./schema-builder-form-modal.type";

import { Modal } from "antd";

import "./schema-builder-form-modal.style.less";

export const SchemaBuilderFormModal = (props: SchemaBuilderFormModalProps) => {
  return (
    <Modal
      className="schema-builder-form-modal"
      width="90vw"
      centered
      {...props}
    />
  );
};
